import { useState } from "react";
import { useParams, useLocation } from "wouter";
import { Eye, EyeOff, Lock } from "lucide-react";
import Button from "./Button";
import { useSetPassword } from "../Use-auth";
import Input from "./Input";

export default function MemberPasswordSetUp() {
    const { token } = useParams();
    const [location, setLocation] = useLocation();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const { mutate } = useSetPassword();

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const query = new URLSearchParams(window.location.search);
    const emailFromLink = query.get("email");

    const submit = () => {
        if (!password || !confirmPassword) {
            setMsg("Please fill in both password fields");
            return;
        }

        if (password.length < 8) {
            setMsg("Password must be at least 8 characters long");
            return;
        }

        if (password !== confirmPassword) {
            setMsg("Passwords do not match");
            return;
        }

        setMsg("");
        setLoading(true);

        mutate(
            { token, password, confirmPassword },
            {
                onSuccess: (data) => {
                    setMsg(data.message);
                    setLoading(false);
                    setLocation("/login");
                },
                onError: (error) => {
                    setMsg(error.message);
                    setLoading(false);
                },
            }
        );
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-background relative overflow-hidden"
            style={{ backgroundImage: 'linear-gradient(to top, #48c6ef 0%, #6f86d6 100%)' }}>
            <div className="w-full max-w-[400px] p-6 shadow bg-[#dfebf8]  rounded-2xl">
                <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg">
                    <Lock className="w-8 h-8 text-white" />
                </div>

                <h2 className="text-xl font-semibold my-2 text-center">
                    Set Your Password
                </h2>

                {emailFromLink && (
                    <div className="mb-4 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
                        <span className="font-medium text-gray-900">Email:</span>{" "}
                        <span className="break-all">{emailFromLink}</span>
                    </div>
                )}

                <div className="relative mb-3">
                    <label className="text-sm font-medium ml-1">
                        New Password
                    </label>
                    <Input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        className="border p-2 w-full pr-10"
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div
                        className="absolute right-2 top-[43px] transform -translate-y-1/2 cursor-pointer"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <EyeOff size={16} className="text-gray-500" /> : <Eye size={16} className="text-gray-500" />}
                    </div>
                </div>

                <div className="relative mb-3">
                    <label className="text-sm font-medium ml-1">
                        Confirm Password
                    </label>
                    <Input
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        className="border p-2 w-full pr-10"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <div
                        className="absolute right-2 top-[43px] transform -translate-y-1/2 cursor-pointer"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                        {showConfirmPassword ? <EyeOff size={16} className="text-gray-500" /> : <Eye size={16} className="text-gray-500" />}
                    </div>
                </div>

                <Button
                    disabled={loading}
                    onClick={submit}
                    variant="success"
                >
                    {loading ? "Setting Password..." : "Set Password"}
                </Button>

                <p
                    className={`mt-4 text-center font-medium ${msg.toLowerCase().includes("success")
                        ? "text-green-600"
                        : "text-red-600"
                        }`}
                >
                    {msg}
                </p>
            </div>
        </div>
    );
}
